'use client'

import { IconArrowRight } from '@tabler/icons-react'
import Image from 'next/image'
import Link from 'next/link'

import { ListingCategoryType } from 'modules/products'
import Breadcrumbs from 'shared/ui/Breadcrumbs'
import { addTestId } from 'shared/utils/tests'

import styles from './AllCategoriesView.module.scss'

type AllCategoriesViewProps = {
  categories: ListingCategoryType[]
}

const AllCategoriesView = ({ categories }: AllCategoriesViewProps) => {
  const breadcrumbs = [{ label: 'Wszystkie', path: null }]

  return (
    <div>
      <div>
        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>
      <h1 className={styles.pageTitle} {...addTestId('page-title')}>Kategorie produktów</h1>
      <div className={styles.categoriesWrapper}>
        {categories &&
          categories.map((category: ListingCategoryType) => {
            const image =
              category.image?.path || '/static/photo-placeholder.svg'
            const subCategories = category?.subCategories || []
            const firstThree = subCategories?.slice(0, 3)

            // @sieradz - halloween - remove this if and check findCategoryBySlug in entity
            // - we are looking for category that is hidden and is not given from backend
            // @Słowik
            if (!category.isVisible) {
              return null
            }

            return (
              <div
                key={category.id}
                className={styles.categoryItem}
                {...addTestId('category-item')}
              >
                <Link href={category?.totalSlug || ''} className={styles.itemHead}>
                  <h2 className={styles.categoryName}>{category.name}</h2>
                  <Image
                    className={styles.categoryImage}
                    src={image}
                    alt={category.name}
                    width={120}
                    height={100}
                  />
                </Link>
                <div className={styles.divider} />
                {firstThree &&
                  firstThree.map((subCat: ListingCategoryType) => (
                    <div key={subCat.id} className={styles.subcategoryItem}>
                      <Link href={subCat?.totalSlug || ''}>
                        <h3 className={styles.subcategoryName}>{subCat.name}</h3>
                      </Link>
                      <div className={styles.subcategoryQuantity}>
                        {subCat.productsCount}
                      </div>
                    </div>
                  ))}
                <Link href={category?.totalSlug || ''} className={styles.seeMore}>
                  Zobacz wszystkie
                  <IconArrowRight />
                </Link>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default AllCategoriesView
